import React from "react";
import { useTheme } from "../../utils/theme";

export default function ThemeToggle({ className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const nextTheme = isDark ? "light" : "dark";

  return (
    <button
      type="button"
      className={`site-theme-toggle ${className}`.trim()}
      aria-label={`Switch to ${nextTheme} mode`}
      aria-pressed={isDark}
      onClick={toggleTheme}
    >
      <span aria-hidden="true">{isDark ? "☀" : "◐"}</span>
      <span>{isDark ? "Light mode" : "Dark mode"}</span>
    </button>
  );
}
